import { Injectable, inject } from '@angular/core';
import { Auth, signInAnonymously, user, User } from '@angular/fire/auth';
import { Observable, BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AppCheckErrorService } from './app-check-error.service';

@Injectable({
    providedIn: 'root'
})
export class AuthenticationService {
    private auth = inject(Auth);
    private appCheckErrorService = inject(AppCheckErrorService);

    private authState$ = new BehaviorSubject<User | null>(null);

    // Public observable for authentication state
    user$: Observable<User | null>;

    constructor() {
        // Initialize authentication state
        this.user$ = user(this.auth).pipe(
            tap(user => {
                this.authState$.next(user);
            })
        );
    }

    /**
     * Perform anonymous authentication
     */
    async signInAnonymously(): Promise<User | null> {
        try {
            const authCredential = await signInAnonymously(this.auth);
            return authCredential.user;
        } catch (error) {
            console.error('Anonymous sign-in failed:', error);
            this.appCheckErrorService.reportIfAppCheckError(error, 'Auth', { operation: 'signInAnonymously' });
            throw error;
        }
    }
} 